import React from 'react'


export default function NotFoundPage () {

  return (
    <div>
      Contenido de 404
    </div>
  )
}
